import axios, { AxiosResponse } from 'axios';

import { GradeModelApi } from './types';


export class GradesService {
  get = async (): Promise<AxiosResponse<GradeModelApi[]>> => axios.get('/auth/grades');
}
